import { all } from 'redux-saga/effects';
import { watchList } from './list';

export function* watchMedicalSpecialties() {
  yield all([watchList()]);
}
